import type { App } from 'vue';
import type { Router } from 'vue-router';

import * as Sentry from '@sentry/vue';

export const initSentry = (app: App, router: Router) => {
  Sentry.init({
    app,
    debug: import.meta.env.VITE_SENTRY_DEBUG === 'true',
    dsn: import.meta.env.VITE_SENTRY_DSN,

    enabled: import.meta.env.VITE_SENTRY_ENABLED === 'true',

    environment: import.meta.env.VITE_ENVIRONMENT,

    release: import.meta.env.VITE_SENTRY_RELEASE_VERSION,
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE),

    tracesSampleRate: parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE),
    ignoreErrors: [
      'Failed to fetch dynamically imported module',
      'Importing a module script failed',
      'error loading dynamically imported module',
      'Unable to preload CSS for',
    ],
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.browserSessionIntegration(),
      Sentry.replayIntegration({
        blockAllMedia: false,
        maskAllInputs: false,
        maskAllText: false,
      }),
      Sentry.vueIntegration({
        tracingOptions: {
          trackComponents: true,
        },
      }),
    ],
    tracePropagationTargets: [
      'localhost',
      /^\//,
      import.meta.env.VITE_BASE_URL.replace('https://', ''),
      import.meta.env.VITE_API_URL.replace('https://', ''),
    ],
  });
};
